import axiosInstance from './axiosInstance';

const getDepositById = (depositId) =>
  axiosInstance.get(`/internal/admin/deposits/${depositId}`);

export default getDepositById;
